import axios from 'axios';
import { mapKeys, camelCase } from 'lodash';
import pathfinder from '@fiverr-private/pathfinder';
import { toFormData } from '../../utils/toFormData';
import { logError } from '../../utils/logError';
import { SignInPayload, SignInResponse, SignInResult } from './signIn.types';

export const signIn = async ({
    login,
    password,
    funnel,
    inBeetlesMigrateSigninWebRollout,
}: SignInPayload): Promise<SignInResult> => {
    try {
        const url = pathfinder('user_sessions');

        const requestData = inBeetlesMigrateSigninWebRollout
            ? {
                  user_session: {
                      login,
                      password,
                  },
                  funnel,
              }
            : toFormData({
                  'user_session[login]': login,
                  'user_session[password]': password,
                  funnel,
              });

        const { data } = await axios.post<SignInResponse>(url, requestData);

        return mapKeys(data, (_, key) => camelCase(key)) as unknown as SignInResult;
    } catch (error) {
        logError({
            message: 'Error during sign in',
            error,
        });

        throw error;
    }
};
